// ย่อรูปก่อนอัปโหลด -- รูปมือถือดิบ 3-8MB/รูป x 5 รูป บนเน็ตมือถือในห้องพักช้ามาก + หน่วยความจำ LINE ในเครื่องเก่าไม่พอ
// ย่อด้านยาวเหลือ 1600px (~0.3-0.5MB) ยังซูมดูรายละเอียดได้ · ย่อไม่ได้ (เช่น HEIC บน Android) -> ส่งไฟล์เดิม
const shrinkImage = (file, maxSide = 1600, quality = 0.8) => new Promise((resolve) => {
  if (!/^image\/(jpeg|png|webp|heic|heif)/i.test(file.type || '')) return resolve(file);
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    try {
      const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.naturalWidth * scale);
      canvas.height = Math.round(img.naturalHeight * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob((blob) => resolve(blob && blob.size < file.size ? blob : file), 'image/jpeg', quality);
    } catch (e) { URL.revokeObjectURL(url); resolve(file); }
  };
  img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
  img.src = url;
});

export default shrinkImage;
